import { render, staticRenderFns } from "./project-header-fixed.vue?vue&type=template&id=0d1bfda0&scoped=true&"
import script from "./project-header-fixed.vue?vue&type=script&lang=js&"
export * from "./project-header-fixed.vue?vue&type=script&lang=js&"
import style0 from "./project-header-fixed.vue?vue&type=style&index=0&id=0d1bfda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1bfda0",
  null
  
)

component.options.__file = "project-header-fixed.vue"
export default component.exports